import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { translations, skillsData, category_names, skillIcons } from './data/translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSun, faMoon, faLanguage, faArrowUpRightFromSquare,
  faPaperPlane, faBars, faTimes, faFilePdf
} from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import emailjs from '@emailjs/browser';

function App() {
  const [lang, setLang] = useState('tr');
  const [theme, setTheme] = useState('dark');
  const [filter, setFilter] = useState('all');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [selectedCert, setSelectedCert] = useState(null);
  const formRef = useRef();

  const t = translations[lang];
  useEffect(() => {
    document.title = lang === 'tr' ? 'Asım Karabulut | Portfolyo' : 'Asim Karabulut | Portfolio';
  }, [lang]);
  useEffect(() => {
    setCurrentImgIndex(0);
  }, [selectedProject]);
  useEffect(() => {
    document.body.className = theme === 'dark' ? 'dark-mode' : 'light-mode';
  }, [theme]);
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') setSelectedProject(null); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setSelectedProject(null);
        setSelectedCert(null);
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);
  const sendEmail = (e) => {
    e.preventDefault();
    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then((result) => {
        alert(lang === 'tr' ? "Mesajınız başarıyla gönderildi!" : "Message sent successfully! ✅");
        formRef.current.reset();
      }, (error) => {
        alert(lang === 'tr' ? "Bir hata oluştu, lütfen tekrar deneyin." : "An error occurred, please try again. ❌");
        console.log(error.text);
      });
  };

  const filteredProjects = filter === 'all'
    ? t.projects
    : t.projects.filter(p =>
      Array.isArray(p.category)
        ? p.category.includes(filter)
        : p.category === filter
    );

  const handleNavLinkClick = () => {
    if (window.innerWidth < 768) setIsMobileMenuOpen(false);
  };

  return (
    <div className="app-container">
      <header className="navbar">
        <div className="nav-brand"></div>

        <button className="mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
        </button>

        <nav className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="nav-links">
            <a href="#about" onClick={handleNavLinkClick}>{t.navAbout}</a>
            <a href="#skills" onClick={handleNavLinkClick}>{t.skillsTitle}</a>
            <a href="#certificates" onClick={handleNavLinkClick}>{t.certificatesTitle || "Sertifikalar"}</a>
            <a href="#projects" onClick={handleNavLinkClick}>{t.navProjects}</a>
            <a href="#contact" onClick={handleNavLinkClick}>{t.navContact}</a>
          </div>
          <div className="nav-actions">
            <button className="icon-btn" onClick={() => setLang(lang === 'tr' ? 'en' : 'tr')} title="Change Language">
              <FontAwesomeIcon icon={faLanguage} /> <span>{lang.toUpperCase()}</span>
            </button>
            <button className="icon-btn" onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')} title="Toggle Theme">
              <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
            </button>
            <a
              href="/CV - ASIM KARABULUT.pdf"
              target="_blank"
              rel="noreferrer"
              className="icon-btn cv-btn"
              title={t.navCv}
              // download="Asim_Karabulut_CV.pdf"
            >
              <FontAwesomeIcon icon={faFilePdf} />
              <span className="cv-text">{t.navCv}</span>
            </a>
          </div>
        </nav>
      </header>

      {/* MAIN CONTENT */}
      <main className="main-content" onClick={() => { if (isMobileMenuOpen) setIsMobileMenuOpen(false) }}>
        {/* HERO SECTION */}
        <section id="about" className="hero-section">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-dot"></span>
              {lang === 'tr' ? 'MERHABA, BEN ASIM' : "HELLO, I'M ASIM"}
            </div>

            <h1 className="hero-title">
              Asım Karabulut<span className="title-dot">.</span>
            </h1>

            <div className="hero-role-row">
              <span className="role-line"></span>
              <span>{t.role}</span>
              <span className="role-amp">&</span>
              <span>{lang === 'tr' ? 'Geliştirici' : 'Developer'}</span>
            </div>

            <p className="hero-desc">{t.aboutText}</p>

            <div className="hero-buttons">
              <a href="#projects" className="btn btn-primary">
                {lang === 'tr' ? 'Projelerimi keşfet' : 'Explore my work'}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
              <a
                href="/CV - ASIM KARABULUT.pdf"
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline"
              >
                {lang === 'tr' ? "CV'mi indir" : 'Download CV'}
                <FontAwesomeIcon icon={faFilePdf} />
              </a>
            </div>

            <div className="hero-socials">
              <a href="https://github.com/asmss" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faGithub} />
                <span>GitHub</span>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mini-arrow" />
              </a>
              <a href="https://www.linkedin.com/in/as%C4%B1m-karabulut-6a874b326" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
                <span>LinkedIn</span>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mini-arrow" />
              </a>
              <a href="https://www.instagram.com/asm_karabulut?igsh=Z2ZiMWsybTlzdGJm&utm_source=qr" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
                <span>Instagram</span>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mini-arrow" />
              </a>

            </div>
          </div>

          <div className="hero-image-container">
            <div className="hero-image-wrapper">
              <img src="/image/asimssss.jpeg" alt="Asım Karabulut" className="hero-image" />
            </div>
          </div>
        </section>

        {/* SKILLS SECTION */}
        <section id="skills" className="section-container">
          <h2 className="section-title">{t.skillsTitle}</h2>
          <div className="skills-layout">
            {Object.entries(skillsData).map(([category, items]) => (
              <div key={category} className="skill-category">
                <h3 className="skill-cat-title">{category_names[category]}</h3>
                <div className="skills-grid">
                  {items.map((skill, index) => (
                    <div key={index} className="skill-item" title={skill}>
                      {skillIcons[skill] || skill}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CERTIFICATES SECTION */}
        <section id="certificates" className="section-container">
          <h2 className="section-title">{t.certificatesTitle}</h2>
          <div className="cert-list">
            {t.certificates.map((cert, index) => (
              <button
                key={index}
                className="cert-row"
                onClick={() => setSelectedCert(cert)}
              >
                <div className="cert-thumb">
                  <img src={cert.img || "/image/default-cert.png"} alt={cert.title} />
                </div>
                <div className="cert-info">
                  <h4>{cert.title}</h4>
                  <p>{cert.issuer}</p>
                </div>
                <div className="cert-meta">
                  <span className="cert-year">{cert.date}</span>
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="cert-arrow" />
                </div>
              </button>
            ))}
          </div>
        </section>

        {/* PROJECTS SECTION */}
        <section id="projects" className="section-container">
          <div className="projects-header">
            <h2 className="section-title">{t.projectsTitle}</h2>
            <div className="project-filters">
              {['all', 'mobile', 'web', 'ai', 'design'].map(cat => (
                <button
                  key={cat}
                  className={`filter-btn ${filter === cat ? 'active' : ''}`}
                  onClick={() => setFilter(cat)}
                >
                  {t[`filter${cat.charAt(0).toUpperCase() + cat.slice(1)}`]}
                </button>
              ))}
            </div>
          </div>

          <div className="projects-grid">
            {filteredProjects.map((p, i) => {
              const displayCat = (filter !== 'all' && Array.isArray(p.category) && p.category.includes(filter))
                ? filter
                : (Array.isArray(p.category) ? p.category[0] : p.category);

              return (
                <div key={i} className="project-card">
                  <div className="project-img-box">
                    <span className="project-badge">
                      {t[`filter${displayCat.charAt(0).toUpperCase() + displayCat.slice(1)}`]}
                    </span>
                    <img src={p.img} alt={p.title} />
                  </div>
                  <div className="project-body">
                    <div className="project-title-row">
                      <h3>{p.title}</h3>
                      <button className="project-arrow" onClick={() => setSelectedProject(p)} aria-label="Detay">
                        <span>Detay</span><FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                      </button>
                    </div>
                    <div className="project-tags">
                      {p.tags?.slice(0, 3).map((tag, idx) => (
                        <span key={idx} className="tag">{tag}</span>
                      ))}
                    </div>
                    <p className="project-desc">{p.desc}</p>
                    <div className="project-footer">
                      <span className="project-index">
                        {String(i + 1).padStart(2, '0')} / {t[`filter${displayCat.charAt(0).toUpperCase() + displayCat.slice(1)}`]?.toUpperCase()}
                      </span>
                      <a href={p.link} target="_blank" rel="noreferrer" className="project-link">
                        {p.type || "GitHub"} <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="mini-arrow" />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* CONTACT SECTION */}
        <section id="contact" className="section-container">
          <h2 className="section-title">{t.contactTitle}</h2>
          <div className="contact-wrapper">
            <form className="contact-form" ref={formRef} onSubmit={sendEmail}>
              <div className="input-row">
                <input type="text" name="name" placeholder={t.formName} required />
                <input type="email" name="email" placeholder={t.formEmail} required />
              </div>
              <textarea name="message" placeholder={t.formMsg} required rows="5"></textarea>
              <button type="submit" className="btn btn-primary">
                {t.formBtn} <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </form>
          </div>
        </section>

      </main>
      {/* PROJECT MODAL */}
      {selectedProject && (
        <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedProject(null)} aria-label="Kapat">
              <FontAwesomeIcon icon={faTimes} />
            </button>

            {/* RESİM SLIDER ALANI */}
            <div className="modal-image-slider">
              {(() => {
                // Eğer project.images varsa onları kullan, yoksa tek resmi dizi yapıp fallback sağla
                const imgs = (selectedProject.images && selectedProject.images.length > 0)
                  ? selectedProject.images
                  : [selectedProject.img];

                return (
                  <>
                    <div className="modal-image">
                      <img src={imgs[currentImgIndex]} alt={selectedProject.title} />

                      {/* Sadece 1'den fazla resim varsa ileri/geri butonlarını göster */}
                      {imgs.length > 1 && (
                        <>
                          <button
                            className="slider-btn prev-btn"
                            onClick={() => setCurrentImgIndex((prev) => (prev === 0 ? imgs.length - 1 : prev - 1))}
                            aria-label="Önceki Resim"
                          >
                            &#10094;
                          </button>
                          <button
                            className="slider-btn next-btn"
                            onClick={() => setCurrentImgIndex((prev) => (prev === imgs.length - 1 ? 0 : prev + 1))}
                            aria-label="Sonraki Resim"
                          >
                            &#10095;
                          </button>
                        </>
                      )}
                    </div>

                    {/* Resim geçiş noktaları (Dots) */}
                    {imgs.length > 1 && (
                      <div className="slider-dots">
                        {imgs.map((_, idx) => (
                          <span
                            key={idx}
                            className={`dot ${idx === currentImgIndex ? 'active' : ''}`}
                            onClick={() => setCurrentImgIndex(idx)}
                          />
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
            </div>

            <div className="modal-body">
              {(() => {
                const primaryCat = Array.isArray(selectedProject.category)
                  ? selectedProject.category[0]
                  : selectedProject.category;
                return (
                  <span className="modal-category">
                    {t[`filter${primaryCat.charAt(0).toUpperCase() + primaryCat.slice(1)}`]?.toUpperCase()}
                  </span>
                );
              })()}

              <h2 className="modal-title">{selectedProject.title}</h2>

              <p className="modal-desc">{selectedProject.desc}</p>

              <div className="modal-tags">
                {selectedProject.tags?.map((tag, idx) => (
                  <span key={idx} className="tag">{tag}</span>
                ))}
              </div>

              <a
                href={selectedProject.github || selectedProject.link}
                target="_blank"
                rel="noreferrer"
                className="modal-btn"
              >
                {lang === 'tr' ? "GitHub'da incele" : "View on GitHub"}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            </div>
          </div>
        </div>
      )}

      {/* CERTIFICATE MODAL — PDF PREVIEW */}
      {selectedCert && (
        <div className="modal-overlay" onClick={() => setSelectedCert(null)}>
          <div className="modal-content cert-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedCert(null)} aria-label="Kapat">
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className="cert-modal-header">
              <div>
                <span className="modal-category">{selectedCert.date}</span>
                <h2 className="modal-title">{selectedCert.title}</h2>
                <p className="modal-desc">{selectedCert.issuer}</p>
              </div>
            </div>

            <div className="cert-modal-pdf">
              <iframe
                src={selectedCert.link}
                title={selectedCert.title}
                frameBorder="0"
              />
            </div>

            <div className="cert-modal-actions">
              <a
                href={selectedCert.link}
                target="_blank"
                rel="noreferrer"
                className="modal-btn"
              >
                {lang === 'tr' ? "Yeni sekmede aç" : "Open in new tab"}
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            </div>
          </div>
        </div>
      )}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Asım Karabulut | asimkarblt07@gmail.com</p>
      </footer>
    </div>
  );
}

export default App;
